module.exports = __webpack_public_path__ + "img/RU.8184aaf3.svg";